import { createReducer, Action, on } from '@ngrx/store';

import { ExtractionRuleListActions } from './extraction-rule-list.actions';
import { ExtractionRuleListState } from './extraction-rule-list.state';
import { AssetSettingFilters } from '../../features/settings/models/user-profile.model';
import { FilterValue } from '../../features/shared/components/filter-by-input/models/filter-by-input.model';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';
import { PresentationType } from '../../features/unified-datapoint/models/datapoint-rule.model';
import { AppActions } from '../app/app.actions';
import { ExtractionRuleActions } from '../extraction-rule/extraction-rule.actions';

export const initialState: ExtractionRuleListState = {
  loading: false,
};

const defaultFilters: FilterValue = {
  presentationType: [PresentationType.HumanReadable],
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      AppActions.LoadInitDataSuccess,
      (state, action): ExtractionRuleListState => ({
        ...state,
        searchFilter: (action.data.assetSettings?.filters as AssetSettingFilters)?.datapoint || defaultFilters,
      })
    ),
    on(
      ExtractionRuleListActions.RefreshDatapointRuleSuccess,
      (state, action): ExtractionRuleListState => ({
        ...state,
        rules: state.rules.map((r) => (r.id === action.item.id ? action.item : r)),
      })
    ),
    on(
      ExtractionRuleListActions.CreateDatapointRule,
      ExtractionRuleListActions.DeleteDatapointRule,

      (state): ExtractionRuleListState => ({ ...state, loading: true, error: undefined })
    ),
    on(
      ExtractionRuleListActions.LoadList,
      (state, action): ExtractionRuleListState => ({
        ...state,
        loading: true,
        error: undefined,
        rules: undefined,
        filter: action.filter,
      })
    ),
    on(
      ExtractionRuleListActions.LoadListSuccess,
      (state, action): ExtractionRuleListState => ({
        ...state,
        loading: false,
        rules: action.rules,
      })
    ),
    on(
      ExtractionRuleListActions.LoadSingleRuleSuccess,
      (state, action): ExtractionRuleListState => ({
        ...state,
        rules: [...(state.rules || []).filter((a) => a.id !== action?.rule?.id), action.rule],
      })
    ),
    on(
      ExtractionRuleListActions.LoadListFail,
      ExtractionRuleListActions.CreateDatapointRuleFail,
      ExtractionRuleListActions.DeleteDatapointRuleFail,
      (state, action): ExtractionRuleListState => ({
        ...state,
        loading: false,
        error: action.error,
      })
    ),
    on(
      ExtractionRuleActions.UpdateRuleBaseSuccess,
      (state, action): ExtractionRuleListState => ({
        ...state,
        rules:
          state.rules?.map((rule) => {
            if (rule.id === action.id) {
              return { ...rule, ...action.rule };
            }

            return rule;
          }) || state.rules,
      })
    ),
    on(
      ExtractionRuleListActions.CreateDatapointRuleSuccess,
      (state, action): ExtractionRuleListState => ({
        ...state,
        loading: false,
        rules: [...(state.rules || []), action.rule],
      })
    ),
    on(
      ExtractionRuleListActions.DeleteDatapointRuleSuccess,
      (state, action): ExtractionRuleListState => ({
        ...state,
        loading: false,
        rules: state.rules?.filter((r) => r.id !== action.id),
      })
    ),
    on(ExtractionRuleListActions.Sort, (state, action): ExtractionRuleListState => ({ ...state, sort: action.sort })),
    on(
      ExtractionRuleListActions.Search,
      (state, action): ExtractionRuleListState => ({ ...state, search: action.search })
    ),
    on(
      ExtractionRuleListActions.Filter,
      (state, action): ExtractionRuleListState => ({ ...state, searchFilter: action.filter })
    ),
    on(
      ExtractionRuleListActions.UpdateCrudOptions,
      (state, action): ExtractionRuleListState => ({
        ...state,
        searchFilter: action.options.searchFilter,
        sort: action.options.sort,
        search: action.options.search,
      })
    )
  )
);

export function reducer(state: ExtractionRuleListState | undefined, action: Action) {
  return featureReducer(state, action);
}
